// extracted by mini-css-extract-plugin
module.exports = {"mute":"AudioButton_mute__3Bj7H"};